import { ExtendApiService } from '@shared/services/ExtendApiService';

class VoiceServiceClass extends ExtendApiService {
  constructor(opts) {
    super(opts);
  }

  downloadReport(data) {
    return this.http.post('detailed/export', data);
  }
}

export const VoiceService = new VoiceServiceClass({
  api_version: 3,
  resource: 'stats/voice'
});
